import { get } from "lodash";
import { getInitialMerchId } from "./get-initial-merch-id";
import { getValueFromBrowserStorage } from "./get-value-from-browser-storage";

const getBasicLSData = (visitorCountryCodeSource: string, visitorCountryCodeKey: string, visitorCountrySource: string, visitorCountryKey: string) => ({
  merchant_id: localStorage.getItem("merchant_id") ?? getInitialMerchId() ?? "",
  country: getValueFromBrowserStorage(visitorCountrySource, visitorCountryKey, false),
  country_alpha_2_code: getValueFromBrowserStorage(visitorCountryCodeSource, visitorCountryCodeKey, true),
  region: localStorage.getItem("region") ?? "",
  territory: localStorage.getItem("territory") ?? "",
  ICP: localStorage.getItem("ICP") ?? "",
  product: localStorage.getItem("product") ?? "",
  topic: localStorage.getItem("topic") ?? "",
  language: localStorage.getItem("chat_language") ?? "",
  user_email: localStorage.getItem("user_email") ?? "",
  account_priority: localStorage.getItem("account_priority") ?? "",
})

export default getBasicLSData;
